import _ from "lodash";
import {filterVolumes, parseAnfVolume, azureAvailableRegions} from '../components/cvs/cvsUtils'

const defaultState = () => ({ volumes: [], filteredVolumes: [], loadingData: true, authorizationCompleted: false, createdVolumes: [] });

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "CVS-ANF:SET-AUTHORIZATION-SUCCESS": {
            return { ...state, authorizationCompleted: true };
        }
        case "CVS-ANF:SET-AUTHORIZATION-FAILED": {
            return { ...state, fetchVolumesError: "No authorization token was provided", authorizationCompleted: true };
        }
        case "CVS-ANF:SET-AUTHORIZATION-ERROR": {
            return {
                ...state,
                fetchVolumesError: _.get(payload, "error.response.data.error.message", "Invalid Token"),
                authorizationCompleted: true
            };
        }
        case "CVS-ANF:FETCH-VOLUME": {
            const volumeObj = _.find(state.volumes, { fileSystemId: payload.volumeId });
            return { ...state, fetchedVolume: volumeObj };
        }
        case "CVS-ANF:START-VOLUMES-POLLING": {
            return { ...state, loadingData: state.volumes.length === 0, fetchVolumesError: null };
        }
        case "CVS-ANF:FETCH-VOLUMES-SUCCESS": {
            const fetchedVolumes = payload.volumes.map(volume => ({
                ...parseAnfVolume({ volume })
            }));

            const filteredCreatedVolumes = state.createdVolumes.filter((volume) => {
                return !_.find(fetchedVolumes, {
                    name: volume.name,
                    subscription: volume.subscription,
                    resourceGroupName: volume.resourceGroupName,
                    capacityPoolName: volume.capacityPoolName,
                    netappAccountName: volume.netappAccountName
                })
            });

            const fetchedWithCreated = fetchedVolumes.concat(filteredCreatedVolumes);
            const availableRegions = azureAvailableRegions.filter(region => {return _.find(fetchedWithCreated,{region: region.value})});
            return {
                ...state,
                fetchVolumesError: null,
                volumes: fetchedWithCreated,
                filteredVolumes: filterVolumes(fetchedWithCreated, state.volumesFilterPhrase),
                loadingData: false,
                availableRegions,
                createdVolumes: filteredCreatedVolumes
            };
        }
        case "CVS-ANF:FETCH-VOLUMES-FAILED": {
            return { ...state, fetchVolumesError: payload, loadingData: false };
        }
        case "CVS-ANF:CREATE-ACCOUNT-DATA": {
            return { ...state, loadingData: true, fetchVolumesError: null };
        }
        case "CVS-ANF:CREATE-ACCOUNT-DATA-SUCCESS": {
            return {
                ...state,
                loadingData: false,
                subscriptions: payload.data,
                subscriptionsMap: _.mapValues(_.keyBy(payload.data, 'subscriptionId'), 'subscriptionName')
            };
        }
        case "CVS-ANF:CREATE-ACCOUNT-DATA-FAILED": {
            return { ...state, loadingData: false, fetchVolumesError: payload };
        }
        case "CVS-ANF:DELETE-VOLUME-ERROR": {
            const deletedVolumeIndex = _.findIndex(state.volumes, { fileSystemId: payload.deletedVolume.fileSystemId });
            const volumeObj = state.volumes[deletedVolumeIndex];
            const volumeToReplace = {...volumeObj, lifeCycleState: "error"};
            const volumes = Object.assign([], state.volumes, {[deletedVolumeIndex]: volumeToReplace});
            return {
                ...state,
                deleteVolumeErrors: { ...state.deleteVolumeErrors, [payload.deletedVolume.fileSystemId]: payload.error },
                loadingData: false,
                volumes,
                filteredVolumes: filterVolumes(volumes, state.volumesFilterPhrase)
            };
        }
        case "CVS-ANF:DELETE-VOLUME": {
            const deletedVolumeIndex = _.findIndex(state.volumes, { fileSystemId: payload.volumeToDelete.fileSystemId });
            const volumeObj = state.volumes[deletedVolumeIndex];
            const volumeToReplace = {...volumeObj, lifeCycleState: "deleting"};
            const volumes = Object.assign([], state.volumes, {[deletedVolumeIndex]: volumeToReplace});
            return {
                ...state,
                volumes,
                filteredVolumes: filterVolumes(volumes, state.volumesFilterPhrase)
            };
        }
        case "CVS-ANF:CREATE-VOLUME": {
            return { ...state, isVolumeCreating: true };
        }
        case "CVS-ANF:CREATE-VOLUME-SUCCESS": {
            const volumePayload = payload.volume;
            const volumeInfo = {
                name: volumePayload.name,
                placement: {
                    account: volumePayload.placement.account,
                    location: volumePayload.location,
                    pool: volumePayload.placement.pool,
                    poolsize: 0,
                    resourceGroup: volumePayload.placement.resourceGroup,
                    subscriptionId: volumePayload.placement.subscription
                },
                properties: {
                    fileSystemId: null,
                    mountIp: volumePayload.details.exportRuleIp,
                    serviceLevel: volumePayload.serviceLevel,
                    state: "Creating",
                    usageThreshold: volumePayload.details.size,
                    usedSize: 0,
                    protocols:[volumePayload.details.protocol],
                    creationToken: volumePayload.name
                }
            };
            const newVolume = parseAnfVolume({ volume: volumeInfo });

            const volumes = state.volumes.concat(newVolume);
            return {
                ...state,
                isVolumeCreating: false,
                volumes,
                filteredVolumes: filterVolumes(volumes, state.volumesFilterPhrase),
                createdVolumes: state.createdVolumes.concat(newVolume)
            };
        }
        case "CVS-ANF:CREATE-VOLUME-FAILED": {
            return { ...state, createVolumeError: payload.error, isVolumeCreating: false };
        }
        case "CVS-ANF:SET-VOLUME-FILTER": {
            return {
                ...state,
                volumesFilterPhrase: payload.value.toLowerCase(),
                filteredVolumes: filterVolumes(state.volumes, payload.value.toLowerCase())
            };
        }
        default:
            return state;
    }
}